import { addHours, parse } from "date-fns";

export default function getStartAndEndDate(event) {
  // console.log("event", event);

  const eventStart = (event["Event-Start"] || "")
    .replace(";", ":")
    .replace(" ", " ");

  const startTime = parse(eventStart || "12:00 PM", "h:mm a", new Date());
  let endTime = addHours(startTime, 1);
  let startDate = new Date();

  if (event["Event-End"]) {
    const eventEnd = (event["Event-End"] || "").replace(";", ":");

    endTime = parse(eventEnd, "h:mm a", new Date());
  }

  if (event["Event-Date"]) {
    startDate = parse(event["Event-Date"], "M/d/yy", new Date());
  }

  startDate.setHours(startTime.getHours(), startTime.getMinutes());

  const endDate = new Date(startDate);

  endDate.setHours(endTime.getHours(), endTime.getMinutes());

  return {
    startDate,
    endDate,
  };
}
